import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import Tabs from '../../components/shared/Tabs';
import './page-projects-start.css';
import BtButton from '../bt-button/bt-button';
import { LinkOutlineIcon, TrashIcon } from '../../components/svgs';
import { ReactComponent as EditIcon } from '../../assets/svg/editIcon.svg';
import { ReactComponent as RefreshIcon } from '../../assets/svg/refreshIcon.svg';
import appState from '../../state/AppStateContainer';
import appEnum, { SavingState } from '../../util/appEnum';
import TableSelector from '../../components/shared/TableSelector/TableSelector';
import services from '../../services';
import FiltersDropdown from '../../components/shared/FiltersDropdown/FiltersDropdown';
import { isEmpty, debounce } from 'lodash';
import { ServiceProjects } from '../../services/service-projects';
import { ServiceUser } from '../../services/service-user';
import SearchBarWithActions from '../../components/shared/SearchBarWithActions/SearchBarWithActions';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import Legends from '../../components/shared/Legends/Legends';
import { NotificationManager } from 'react-notifications';
import * as Sentry from "@sentry/react";
import { ReactComponent as PresentationIcon } from '../../assets/svg/presentationIcon.svg';
import PaginationWithGoTo from '../pagination-with-goto/pagination-with-goto';
import { ReactComponent as StationIcon } from '../../assets/svg/stationIcon.svg';
import { ReactComponent as HealthBuildingIcon } from '../../assets/svg/healthBuildingIcon.svg';
import { ReactComponent as HouseIcon } from '../../assets/svg/houseIcon.svg';
import { ReactComponent as HotelIcon } from '../../assets/svg/hotelIcon.svg';
import { ReactComponent as PowerIcon } from '../../assets/svg/powerIcon.svg';
import { ReactComponent as FactoryIcon } from '../../assets/svg/factoryIcon.svg';
import { ReactComponent as BuildingIcon } from '../../assets/svg/buildingIcon.svg';
import { ReactComponent as RoadIcon } from '../../assets/svg/roadIcon.svg';
import { ReactComponent as PingPongIcon } from '../../assets/svg/pingPongIcon.svg';
import { ReactComponent as MeetingIcon } from '../../assets/svg/meetingIcon.svg';
import { ReactComponent as FootballFieldIcon } from '../../assets/svg/footballFieldIcon.svg';
import { ReactComponent as ShopIcon } from '../../assets/svg/shopIcon.svg';
import { ReactComponent as TunnelIcon } from '../../assets/svg/tunnelIcon.svg';
import { ReactComponent as SchoolBagIcon } from '../../assets/svg/schoolBagIcon.svg';
import { ReactComponent as EmailCheckIcon } from '../../assets/svg/emailCheckIcon.svg';
import { ReactComponent as UploadIcon } from '../../assets/svg/uploadIcon.svg';
import { ReactComponent as ArrowStrokeDown } from '../../assets/svg/arrow_stroke_down.svg';
import { ReactComponent as DownloadIcon } from '../../assets/svg/downloadIcon.svg';
import AppLayout from '../../components/layout/app-layout/app-layout';
import DataTable from '../../components/shared/DataTable/DataTable';
import CustomizationMenu from '../../components/shared/CustomizationMenu/CustomizationMenu';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import { Trans, useTranslation } from 'react-i18next';
import { CustomAvatar } from '../../components/shared';
import Modal from '../../components/shared/Modal/Modal';
import AppCreateProject from '../app-create-project/app-create-project';
import TeamBuilder from '../../components/shared/TeamBuilder/TeamBuilder';
import ImportNextProjectModal from './ImportNextProjectModal';
import ExportNextProjectModal from './ExportNextProjectModal';
import UpdateFromNextModal from './UpdateFromNextModal';
import { ServiceNextProject } from "../../services/ServiceNextProject";
import { useTableSorting } from '../../util/useTableSorting';
import { tableIcons } from '../app-supplier-database/icons';
import { autosave } from '../../util';


const MAX_CLOSED_PROJECTS = 10;
const MAX_OPEN_PROJECTS = 10;

export const projectTypeToIconMap = (props) => ({
  'Kontorsbyggnader': <PresentationIcon {...props} />,
  'Samfärdsel': <StationIcon {...props} />,
  'Sjuk & Hälsovård': <HealthBuildingIcon {...props} />,
  'Gruppbyggda småhus': <HouseIcon {...props} />,
  'Hotell / Restaurang': <HotelIcon {...props} />,
  'Kraft & Belysning': <PowerIcon {...props} />,
  'Industrier / Verkstad / Lager': <FactoryIcon {...props} />,
  'Flerbostadshus': <BuildingIcon {...props} />,
  'Vägar / Gator / Broar / Vatten': <RoadIcon {...props} />,
  'Idrott / Fritidsanläggning': <PingPongIcon {...props} />,
  'Samlingslokaler': <MeetingIcon {...props} />,
  'Idrott Utomhus': <FootballFieldIcon {...props} />,
  'Affärslokaler': <ShopIcon {...props} />,
  'Tunnel': <TunnelIcon {...props} />,
  'Skola / Förskola': <SchoolBagIcon {...props} />,
});

const importAll = (r) => {
  let images = {};
  r.keys().forEach(item => { images[item.replace('./', '')] = r(item); });
  return images
};

const images = importAll(require.context('../../assets/images/KommunIcons', false, /\.(png|jpe?g|svg)$/));

export const consolidateColumnConfiguration = (projectListConfig, defaultColumnConfiguration, saveColumnConfig) => {
  const columnNamesInConfig = projectListConfig.map(x => x.name);
  const defaultColumnNames = defaultColumnConfiguration.map(x => x.name);
  const newColumns = defaultColumnConfiguration.filter(x => !columnNamesInConfig.includes(x.name));
  const updatedColumns = projectListConfig.filter(x => defaultColumnNames.includes(x.name)); // remove columns which don't exist in default column configuration

  if (newColumns.length || updatedColumns.length !== projectListConfig.length) {
    // Insert each new column after the column it appears after in the default column configuration
    newColumns.forEach((column) => {
      let prevIndex = defaultColumnNames.indexOf(column.name) - 1;
      let insertIndex;
      if (prevIndex >= 0) {
        let prevName = defaultColumnNames[prevIndex];
        insertIndex = updatedColumns.findIndex(c => c.name === prevName) + 1;
      } else {
        insertIndex = 0;
      }
      updatedColumns.splice(insertIndex, 0, column);
    });
    saveColumnConfig(updatedColumns);
  }

  return updatedColumns;
};

export default function PageProjectsStart({ addProject, removeProject, history, clearNotifications, clearAllNotifications, allNextProjects, fetchAllNextProjects, allNextCustomers, fetchAllNextCustomers }) {
  const [t] = useTranslation('projects');
  const [tPagination] = useTranslation('pagination', { keyPrefix: 'pagination' });
  const getPageLimit = (selectedTab) => {
    return selectedTab ? MAX_CLOSED_PROJECTS : MAX_OPEN_PROJECTS;
  };
  const [projects, setProjects] = useState([]);
  const [selectedProjectTab, setSelectedProjectTab] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const tableRef = useRef(null);
  const [cities, setCities] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(MAX_OPEN_PROJECTS);
  const [isLoading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [totalAreas, setTotalAreas] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortConfig, setSortConfig] = useState({ sortBy: 'createdAt', sortOrder: 'desc' });
  const [sendToNext, setSendToNext] = useState(false);
  const [editingProject, setEditingProject] = useState(false);
  const [parentProjectForEdit, setParentProjectForEdit] = useState(null);

  const { getSortingProps, setSorting: saveSortingPreference, sorting } = useTableSorting(
    'projectsList',
    appEnum.userPrefrences.projectOverview
  );

  const sortingProps = getSortingProps();

  // Track if hook has loaded (orderByField will be set when loaded, even if empty string)
  const hookHasLoaded = useMemo(() => {
    // Hook is considered loaded if orderByField exists OR if orderBy is -1 (meaning no saved sorting)
    return sorting.orderByField !== undefined || sorting.orderBy === -1;
  }, [sorting.orderByField, sorting.orderBy]);

  const [filtersData, setFiltersData] = useState({
    projectType: [],
    kommun: [],
    phase: [],
    users: [],
    next: [],
  });
  const [showFilter, toggleFilter] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  const [finishProjectInfo, setFinishProjectInfo] = useState();
  const [finishProjectLoader, setFinishProjectLoader] = useState(false);
  const [showFinishProjectModal, setShowFinishProjectModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [showNextImportModal, setShowNextImportModal] = useState(false);
  const [nextImportModalKey, setNextImportModalKey] = useState(0);
  const [showExportNextModal, setShowExportNextModal] = useState(false);
  const [exportNextProjectRow, setExportNextProjectRow] = useState(null);
  const [exportNextModalKey, setExportNextModalKey] = useState(0);
  const [exportNextPreview, setExportNextPreview] = useState(null);
  const [showUpdateFromNextModal, setShowUpdateFromNextModal] = useState(false);
  const [updateFromNextRow, setUpdateFromNextRow] = useState(null);
  const [updateFromNextModalKey, setUpdateFromNextModalKey] = useState(0);
  const [clientValidForEdit, setClientValidForEdit] = useState(false);
  const appCreateProjectRef = useRef(null);
  const isInitialMount = useRef(true);
  const hasInitialFetchRun = useRef(false);
  const isSortingChange = useRef(false); // Track if sort change is from user interaction
  const isUpdatingURL = useRef(false); // Track if we're programmatically updating URL
  const fetchRequestId = useRef(0); // Track fetch requests to ignore stale responses
  const isLoadingInitialData = useRef(true);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // URL query parameter helpers for page number (defined before use)
  const getPageFromURL = useCallback(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const page = parseInt(searchParams.get('page'), 10);
    return (page > 0 && !isNaN(page)) ? page : 1;
  }, [history]);

  const updatePageInURL = useCallback((page, replace = false) => {
    // Set flag BEFORE updating URL to ensure history listener sees it
    isUpdatingURL.current = true;

    const searchParams = new URLSearchParams(history.location.search);
    if (page === 1) {
      searchParams.delete('page'); // Remove ?page=1 for cleaner URLs
    } else {
      searchParams.set('page', page.toString());
    }
    const newSearch = searchParams.toString();
    const updateMethod = replace ? history.replace : history.push;
    updateMethod({
      pathname: history.location.pathname,
      search: newSearch ? `?${newSearch}` : ''
    });

    // Reset flag after a delay to ensure history listener skips this update
    // Use a longer delay to be safe
    setTimeout(() => {
      isUpdatingURL.current = false;
    }, 300);
  }, [history]);

  // Sync hook's sorting state with sortConfig for API calls (only on initial load)
  const prevSortingRef = useRef({ field: '', direction: '' });
  useEffect(() => {
    if (!hookHasLoaded) return; // Wait for hook to load
    if (!initialDataLoaded) return; // Wait for filter preferences to be loaded so initial fetch uses them
    if (!isInitialMount.current) return; // Only sync on initial load, not during user interactions

    // Read directly from appState to ensure we have the latest data
    const savedPreferences = appState.getProjectOverviewPreferences();
    const savedTableSorting = savedPreferences?.tableSorting?.projectsList;

    // Only apply saved sort if one exists, otherwise keep default (don't force a sort)
    const hasSavedSort = savedTableSorting?.orderByField && savedTableSorting.orderByField !== '';

    if (hasSavedSort) {
      // Use hook's state if available, otherwise fall back to appState directly
      const newSortConfig = (sortingProps.defaultOrderByField && savedTableSorting?.orderByField === sortingProps.defaultOrderByField)
        ? {
          sortBy: sortingProps.defaultOrderByField,
          sortOrder: sortingProps.defaultOrderDirection
        }
        : {
          sortBy: savedTableSorting.orderByField,
          sortOrder: savedTableSorting.orderDirection
        };

      // Only update if sorting has actually changed
      const sortingChanged =
        prevSortingRef.current.field !== newSortConfig.sortBy ||
        prevSortingRef.current.direction !== newSortConfig.sortOrder;

      if (sortingChanged) {
        prevSortingRef.current = { field: newSortConfig.sortBy, direction: newSortConfig.sortOrder };
        setSortConfig(newSortConfig);
      }
    } else {
      // No saved sort - use default for API but don't update sortConfig (keep initial default)
      // This ensures DataTable doesn't show a sort indicator
      prevSortingRef.current = { field: 'createdAt', direction: 'desc' };
    }

    // Trigger initial fetch if it hasn't run yet (filtersData already set by initial-data effect)
    if (!hasInitialFetchRun.current) {
      hasInitialFetchRun.current = true;
      const initialPage = getPageFromURL(); // Read from URL instead of preferences
      setCurrentPage(initialPage);

      // Determine the correct sort config to use
      const sortToUse = hasSavedSort
        ? (sortingProps.defaultOrderByField && savedTableSorting?.orderByField === sortingProps.defaultOrderByField)
          ? {
            sortBy: sortingProps.defaultOrderByField,
            sortOrder: sortingProps.defaultOrderDirection
          }
          : {
            sortBy: savedTableSorting.orderByField,
            sortOrder: savedTableSorting.orderDirection
          }
        : { sortBy: 'createdAt', sortOrder: 'desc' };

      // Pass filtersData so refresh-with-filters uses saved filter preferences
      fetchProjects(initialPage, true, sortToUse, searchValue, filtersData).then(() => {
        isInitialMount.current = false;
      });
    }
  }, [hookHasLoaded, initialDataLoaded, sortingProps.defaultOrderByField, sortingProps.defaultOrderDirection, getPageFromURL, filtersData]);

  // Listen for URL changes (browser back/forward) and update page state
  // Also reload sorting preferences when navigating back to projects list
  useEffect(() => {
    const unlisten = history.listen((location) => {
      // Skip completely if we're programmatically updating the URL (to avoid circular updates)
      if (isUpdatingURL.current) {
        return;
      }

      // Only update if we're on the projects list page
      if (location.pathname.includes('/projects') && !location.pathname.match(/\/projects\/[^/]+$/)) {
        const searchParams = new URLSearchParams(location.search);
        const pageFromURL = parseInt(searchParams.get('page'), 10);
        const validPage = (pageFromURL > 0 && !isNaN(pageFromURL)) ? pageFromURL : 1;

        if (!isInitialMount.current) {
          // Reload sorting preferences when navigating back
          const savedPreferences = appState.getProjectOverviewPreferences();
          const savedTableSorting = savedPreferences?.tableSorting?.projectsList;
          const hasSavedSort = savedTableSorting?.orderByField && savedTableSorting.orderByField !== '';

          if (hasSavedSort) {
            // Update sortConfig with saved sorting
            const newSortConfig = {
              sortBy: savedTableSorting.orderByField,
              sortOrder: savedTableSorting.orderDirection
            };

            // Check if sorting actually changed to avoid unnecessary updates
            if (sortConfig.sortBy !== newSortConfig.sortBy || sortConfig.sortOrder !== newSortConfig.sortOrder) {
              setSortConfig(newSortConfig);
            }

            // Update page if needed (fetch will be triggered by page or sort change effect)
            if (validPage !== currentPage) {
              setCurrentPage(validPage);
            } else {
              const isOpen = selectedProjectTab === 0;
              fetchProjects(validPage, isOpen, newSortConfig, searchValue, filtersData);
            }
          } else {
            // No saved sort, just update page
            if (validPage !== currentPage) {
              setCurrentPage(validPage);
            }
          }
        }
      }
    });
    return unlisten;
  }, [history, currentPage, sortConfig, selectedProjectTab, searchValue, filtersData]);

  const hasActiveFilters = useMemo(() => {
    return !isEmpty(filtersData.kommun) ||
      !isEmpty(filtersData.projectType) ||
      !isEmpty(filtersData.phase) ||
      !isEmpty(filtersData.users) ||
      !isEmpty(filtersData.next);
  }, [filtersData]);

  const fetchProjects = async (page = currentPage, isOpen = null, sort = sortConfig, search = searchValue, filters = filtersData, options = {}) => {
    // Increment request ID to track this request
    const requestId = ++fetchRequestId.current;

    setLoading(true);

    try {
      const params = {
        pageIndex: page,
        pageSize: getPageLimit(selectedProjectTab),
        sortBy: sort.sortBy,
        sortOrder: sort.sortOrder,
      };

      if (isOpen !== null) {
        params.isOpen = isOpen;
      }

      if (search && search.trim()) {
        params.searchFilter = search.trim();
      }

      // Add filter parameters (always send to server, even if empty)
      if (filters.kommun && filters.kommun.length > 0) {
        params.kommun = filters.kommun;
      }
      if (filters.projectType && filters.projectType.length > 0) {
        params.projectType = filters.projectType;
      }
      if (filters.phase && filters.phase.length > 0) {
        params.phase = filters.phase;
      }
      if (filters.users && filters.users.length > 0) {
        params.users = filters.users;
      }
      if (filters.next && filters.next.length > 0) {
        params.next = filters.next;
      }

      const response = await ServiceProjects.getProjectList(params);

      // Ignore stale responses (if a newer request has been made)
      if (requestId !== fetchRequestId.current) {
        return;
      }

      setProjects(response?.data || []);

      // Always use server pagination
      setTotalCount(response?.pagination?.totalCount || 0);
      setTotalPages(response?.pagination?.totalPages || 1);
      setPageLimit(response?.pagination?.limit || getPageLimit(selectedProjectTab));
    } catch (error) {
      console.error('Failed to fetch projects:', error);
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const refreshProjectList = async () => {
    const isOpen = selectedProjectTab === 0 ? true : false;
    await fetchProjects(currentPage, isOpen, sortConfig, searchValue);
  };

  const searchContextRef = useRef({});
  searchContextRef.current = { selectedProjectTab, sortConfig, currentPage, filtersData, fetchProjects };

  const debouncedSearchRef = useRef(null);
  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = debounce((value) => {
      const ctx = searchContextRef.current;
      const isOpen = ctx.selectedProjectTab === 0;
      if (ctx.currentPage === 1) {
        ctx.fetchProjects(1, isOpen, ctx.sortConfig, value, ctx.filtersData);
      } else {
        setCurrentPage(1);
      }
    }, 1000);
  }

  useEffect(() => () => debouncedSearchRef.current?.cancel(), []);

  const search = (value) => {
    setSearchValue(value);
    debouncedSearchRef.current(value);
  };

  const DEFAULT_SORT = { sortBy: 'createdAt', sortOrder: 'desc' };

  const toggleSort = (fieldName) => {
    const prevSort = sortConfig;
    const isSameColumn = prevSort.sortBy === fieldName;

    let newSort;
    if (!isSameColumn) {
      newSort = { sortBy: fieldName, sortOrder: 'asc' };
    } else if (prevSort.sortOrder === 'asc') {
      newSort = { sortBy: fieldName, sortOrder: 'desc' };
    } else {
      newSort = DEFAULT_SORT;
    }

    // Mark that this is a user-initiated sort change
    isSortingChange.current = true;

    // Save sorting preference
    saveSortingPreference(-1, newSort.sortOrder, newSort.sortBy);

    // Update state and fetch directly with new sort config
    const isOpen = selectedProjectTab === 0;

    fetchProjects(1, isOpen, newSort, searchValue, filtersData);

    // Update state after fetch starts
    setSortConfig(newSort);
    if (currentPage !== 1) {
      setCurrentPage(1);
      updatePageInURL(1, true);
    }

    // Reset flag after effects have had a chance to see it
    setTimeout(() => {
      isSortingChange.current = false;
    }, 500);
  };

  const customHeader = (title, fieldName) => {
    const { SortArrow } = tableIcons;
    const isActive = sortConfig.sortBy === fieldName;
    const titleClass = isActive ? 'sorted' : '';

    return (
      <div onClick={() => toggleSort(fieldName)} className={`sup-db-title ${titleClass}`}>
        {title}
        {isActive && <ArrowStrokeDown style={{ width: '11px', transform: sortConfig.sortOrder == 'asc' ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'all 0.2s ease-in-out' }} />}
      </div>
    );
  };

  const COLUMN_NAMES = {
    project: t('table.header.project', 'Projekt'),
    responsible: t('table.header.responsible', 'Ansvarig'),
    phase: t('table.header.phase', 'Skede'),
    projectNo: t('table.header.projectNo', 'Projektnummer'),
    projectType: t('table.header.projectType', 'Projekttyp'),
    region: t('table.header.region', 'Kommun'),
    requests: t('table.header.requests', 'Upphandlingar'),
    estCost: t('table.header.estCost', 'Estimerad projektkostnad'),
    users: t('table.header.users', 'Användare'),
    members: t('table.header.members', 'Medarbetare')
  };

  const DEFAULT_COLUMN_CONFIGURATION = [
    {
      name: 'Projekt',
      displayName: COLUMN_NAMES.project,
      show: true,
      static: true,
    }, {
      name: 'Responsible',
      displayName: COLUMN_NAMES.responsible,
      show: true,
    },
    {
      name: 'Members',
      displayName: COLUMN_NAMES.members,
      show: true,
    },
    {
      name: 'Skede',
      displayName: COLUMN_NAMES.phase,
      show: true,
    }, {
      name: 'Projektnummer',
      displayName: COLUMN_NAMES.projectNo,
      show: true,
    }, {
      name: 'Projekttyp',
      displayName: COLUMN_NAMES.projectType,
      show: false,
    }, {
      name: 'Kommun',
      displayName: COLUMN_NAMES.region,
      show: true,
    }, {
      name: 'Upphandlingar',
      displayName: COLUMN_NAMES.requests,
      show: true,
    }, {
      name: 'Estimerad projektkostnad',
      displayName: COLUMN_NAMES.estCost,
      show: true,
    }
  ];

  const saveTableColumns = async (data) => {
    await ServiceUser.updatePreferences(appState.getUserId(), data, appEnum.userPrefrences.projectTable);
  }
  const updateColumns = async (data) => {
    await saveTableColumns(data);
    setColumns(data);
  }
  const setupTableConfiguration = async () => {
    await appState.getUserDetails();
    const projectListConfig = appState.getProjectListPreferences();
    setColumns(projectListConfig ? consolidateColumnConfiguration(projectListConfig, DEFAULT_COLUMN_CONFIGURATION, saveTableColumns) : DEFAULT_COLUMN_CONFIGURATION);
  }

  useEffect(() => {
    columns.forEach((column) => {
      column.displayName = DEFAULT_COLUMN_CONFIGURATION.find(x => x.name === column.name)?.displayName;
    });
  }, [DEFAULT_COLUMN_CONFIGURATION]);

  useEffect(() => {
    (async function () {
      setCities((await services.getCities()).map(city => ({ label: city, value: city })));
      setProjectTypes((await ServiceProjects.getProjectTypes()).map(pT => ({ label: pT.name, value: pT._id })));
      await setupTableConfiguration();
      const filtersPreferences = appState.getProjectFilterPreferences();
      setFiltersData((prev) => ({
        ...prev,
        ...filtersPreferences
      }));

      const users = await ServiceUser.getTasksUsers();
      setUsers(users.filter(user => user.isActive).map(user => ({ label: user.name, value: user._id, projects: user.projects, role: user.role, avatarUrl: user.avatarUrl })));

      isLoadingInitialData.current = false;
      setInitialDataLoaded(true);

    })();
  }, []);

  useEffect(() => {
    if (isInitialMount.current) return;

    const isOpen = selectedProjectTab === 0;
    // Reset to page 1 when tab changes (not when page changes)
    // The currentPage useEffect will handle fetching after state updates
    updatePageInURL(1, true); // Use replace for tab changes (don't clutter history)
    setCurrentPage(1);
  }, [selectedProjectTab, updatePageInURL]);

  // Use a ref to track the latest sortConfig for the page effect
  const sortConfigRef = useRef(sortConfig);
  useEffect(() => {
    sortConfigRef.current = sortConfig;
  }, [sortConfig]);

  useEffect(() => {
    if (isInitialMount.current) return;

    // Skip if this page change was triggered by a sort change (handleOrderChange handles it)
    if (isSortingChange.current) {
      return;
    }

    const isOpen = selectedProjectTab === 0;
    fetchProjects(currentPage, isOpen, sortConfig, searchValue);
  }, [currentPage, sortConfig, selectedProjectTab]);

  // Refetch projects when filters change (server-side filtering)
  useEffect(() => {
    // Skip during initial mount or while initial data is still loading
    // This prevents the race condition where loading filter preferences
    // after initial fetch would reset the page to 1
    if (isInitialMount.current || isLoadingInitialData.current) return;

    const isOpen = selectedProjectTab === 0 ? true : false;
    // Reset to page 1 when filters change
    setCurrentPage(1);
    updatePageInURL(1, true);
    fetchProjects(1, isOpen, sortConfig, searchValue);
  }, [filtersData]);

  useEffect(() => {
    if (tableRef.current?.dataManager) {
      const limit = getPageLimit(selectedProjectTab);
      tableRef.current.dataManager.changePageSize(limit);
      setPageLimit(limit);
    }
  }, [selectedProjectTab]);

  const isWriteAccessRole = appState.isWriteAccessRole();

  const getNotificationCount = projectNotifications => {
    if (projectNotifications && projectNotifications > 0) {
      return projectNotifications;
    }
    return 0;
  };

  const updateProjectOpen = async (newStatus, finishProjectInfo) => {
    try {
      await ServiceProjects.updateProjectOpenStatus(finishProjectInfo.slug, newStatus);
      setProjects(oldProjects => oldProjects.map(oldProject =>
        oldProject._id === finishProjectInfo._id ? { ...oldProject, isOpen: newStatus } : oldProject
      ));

      NotificationManager.success(
        t('notification.success.description.statusUpdated', 'Statusen har blivit uppdaterad.'),
        t('notification.success.title.statusUpdated', 'Ändring utförd')
      );
    } catch (error) {
      console.error('Failed to toggle project status:', error);
      NotificationManager.error(
        t('notification.error.description.statusUpdateFailed', 'Det gick inte att uppdatera projektstatus.'),
        t('notification.error.title.statusUpdateFailed', 'Misslyckat')
      );
    }
  }

  const onSendToNextError = (error) => {
    console.error('Failed to export project to Next:', error);
    let errorMessage = t('sendToNextProject.error.text', 'Det gick inte att skicka projektet till Next Project');
    if (error?.response?.data?.error) {
      errorMessage = error.response.data.error;
    }
    NotificationManager.error(
      errorMessage,
      t('sendToNextProject.error.headline', 'Fel'),
    );
  }

  const onSendToNextSuccess = (response) => {
    const hasFailedUpdates = response.failedUpdates && response.failedUpdates.length > 0;
    const hasMissingAccounts = response.missingAccounts && response.missingAccounts.length > 0;
    if (hasFailedUpdates) {
      NotificationManager.warning(
        t(
          'sendToNextProject.warning.failedUpdates.text',
          'Projektet har skickats, men följande inköp kunde inte uppdateras i Next: {{failed_list}}.',
          { failed: response.failedUpdates },
        ),
        t('sendToNextProject.warning.failedUpdates.headline', 'Skickat')
      );
    }
    if (hasMissingAccounts) {
      NotificationManager.warning(
        t(
          'sendToNextProject.warning.missingAccounts.text',
          'Projektet har skickats, men kontokoder saknas för följande inköp: {{missingAccounts_list}}.',
          { missingAccounts: response.missingAccounts },
        ),
        t('sendToNextProject.warning.missingAccounts.headline', 'Skickat')
      );
    }
    if (!hasFailedUpdates && !hasMissingAccounts) {
      NotificationManager.success(
        t('sendToNextProject.success.text', 'Projektet har skickats till Next Project'),
        t('sendToNextProject.success.headline', 'Skickat')
      );
    }
    refreshProjectList();
  }

  const onUpdateFromNextSuccess = (response) => {
    if (response.missingAccounts && response.missingAccounts.length > 0) {
      NotificationManager.warning(
        t(
          'updateFromNextProject.warning.missingAccounts.text',
          'Projektet har uppdaterats, men kategorier saknas för följande konton: {{missingAccounts_list}}.',
          { missingAccounts: response.missingAccounts },
        ),
        t('updateFromNextProject.warning.missingAccounts.headline', 'Uppdaterat')
      );
    } else {
      NotificationManager.success(
        t('updateFromNextProject.success.text', 'Projektet har uppdaterats'),
        t('updateFromNextProject.success.headline', 'Uppdaterat')
      );
    }
    refreshProjectList();
  }

  const onUpdateFromNextError = (error) => {
    console.error('Failed to update project from Next:', error);
    NotificationManager.error(
      error?.response?.data?.error ?? t('updateFromNextProject.error.text', 'Det gick inte att hämta projektet från Next Project'),
      t('updateFromNextProject.error.headline', 'Fel'),
    );
  }

  const getColumns = () => {
    const getProjectTypeComponent = (rowData) => (
      <TooltipContainer renderReferenceComponent={(className, ref) =>
        <div ref={ref} className={`projectTypeContainer ${className}`} style={{ visibility: rowData.projectTypeName ? 'visible' : 'hidden' }}>
          {projectTypeToIconMap({ width: 18, height: 18 })[rowData.projectTypeName]}
        </div>
      }>
        {rowData.projectTypeName && t(`projectType.${rowData.projectTypeName.replace(/[\s&/]/g, '')}`, rowData.projectTypeName)}
      </TooltipContainer>
    )

    return [...columns.filter(column => column.show || column.static).map(column => {
      switch (column.name) {
        case 'Projekt':
          return {
            title: customHeader(COLUMN_NAMES.project, 'name'),
            field: 'name',
            sorting: false,
            render: (rowData) => (
              <div className="projectColumn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div>{getProjectTypeComponent(rowData)}</div>
                  <span style={{ color: 'var(--gray-900)', fontSize: '16px' }}>{rowData.name}</span>
                  {appState.currentOrganization.hasNextProject && rowData.nextProjectId && (
                    <TooltipContainer renderReferenceComponent={(className, ref) => (
                      <span
                        ref={ref}
                        className={className}
                        style={{ display: 'inline-flex', color: 'var(--gray-400)', marginLeft: '8px', verticalAlign: 'middle' }}
                      >
                        <LinkOutlineIcon />
                      </span>
                    )}>
                      {t('table.row.nextLinked', 'Projektet är kopplat till Next Project')}
                    </TooltipContainer>
                  )}
                </div>
                <div><NotificationCounter counter={getNotificationCount(rowData.notification)} /></div>
              </div>
            ),
            cellStyle: {
              width: '400px'
            },
          };
        case 'Responsible':
          return {
            title: customHeader(COLUMN_NAMES.responsible, 'responsibleName'),
            field: 'responsibleName',
            sorting: false,
            render: rowData => {
              const responsible = rowData?.responsible;
              return (
                <div>
                  {responsible && (
                    <div className="responsible" key={responsible._id}>
                      <CustomAvatar src={responsible.avatarUrl || undefined} alt={responsible.name} size="30px" />
                      <div>{responsible.name}</div>
                    </div>
                  )}
                </div>
              );
            },
            cellStyle: { width: '200px' },
            align: 'left'
          };
        case 'Members':
          return {
            title: customHeader(COLUMN_NAMES.members, 'membersCount'),
            field: 'membersCount',
            sorting: false,
            render: rowData => {
              const members = rowData?.members || [];

              return (
                <TeamBuilder
                  mode="project"
                  users={users}
                  areaUsers={members}
                  currentProject={rowData}
                  avatarSize="30px"
                  setAreaUsers={(updatedMembers) => {
                    setProjects(oldProjects =>
                      oldProjects.map(project =>
                        project._id === rowData._id
                          ? { ...project, members: updatedMembers }
                          : project
                      )
                    );
                  }}
                />
              );
            },
            align: 'left'
          };
        case 'Skede':
          return {
            title: customHeader(COLUMN_NAMES.phase, 'phase'),
            field: 'phase',
            sorting: false,
            render: rowData => {
              const [currentPhase, setCurrentPhase] = useState(rowData?.phase || '');

              const options = [
                { label: t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'), value: 'Anbud/Kalkyl' },
                { label: t('projectPhase.InköpProduktion', 'Inköp/Produktion'), value: 'Inköp/Produktion' }
              ];

              const selectedPhase = currentPhase
                ? { label: options.find(option => option.value === currentPhase)?.label || '', value: currentPhase }
                : null;

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <TableSelector
                    options={options}
                    value={selectedPhase}
                    isClearable={true}
                    isSearchable={false}
                    onChange={async (selectedValue) => {
                      const newPhase = selectedValue?.value || '';

                      if (newPhase === currentPhase) return;

                      setCurrentPhase(newPhase);
                      setProjects(oldProjects =>
                        oldProjects.map(project =>
                          project.slug === rowData.slug
                            ? { ...project, phase: newPhase }
                            : project
                        )
                      );

                      appState.setAutosavingState(SavingState.SAVING);
                      try {
                        await ServiceProjects.updateProjectPhase(rowData.slug, newPhase);
                        appState.setAutosavingState(SavingState.DONE);
                      } catch (error) {
                        console.error('Failed to update phase:', error);
                        // Revert on error
                        setProjects(oldProjects =>
                          oldProjects.map(project =>
                            project.slug === rowData.slug
                              ? { ...project, phase: previousPhase }
                              : project
                          )
                        );
                        appState.setAutosavingState(SavingState.HIDDEN);
                      }
                    }}
                  />
                </div>
              );
            },
            cellStyle: { width: '200px' },
            align: 'left'
          };
        case 'Projektnummer':
          return {
            title: customHeader(COLUMN_NAMES.projectNo, 'number'),
            field: 'number',
            sorting: false,
          };
        case 'Projekttyp':
          return {
            title: customHeader(COLUMN_NAMES.projectType, 'projectTypeName'),
            field: 'projectTypeName',
            sorting: false,
            cellStyle: { width: 'unset' },
            width: '100px',
            render: (rowData) => rowData.projectTypeName && t(`projectType.${rowData.projectTypeName.replace(/[\s&/]/g, '')}`, rowData.projectTypeName)
          };
        case 'Kommun':
          return {
            title: customHeader(COLUMN_NAMES.region, 'province'),
            field: 'province',
            sorting: false,
            render: (rowData) => {
              let normalizedKommunName;
              let kommunIcon;
              if (rowData.province) {
                normalizedKommunName = rowData.province.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');

                kommunIcon = images[`${normalizedKommunName}.png`];
              }
              return (
                <div style={{ display: 'flex', gap: '10px' }}>
                  {rowData.province && kommunIcon && <img width={'17px'} height={'20px'} src={kommunIcon} />}
                  <span>{rowData.province === "Utomlands" ? "Utomlands / Other" : rowData.province || '-'}</span>
                </div>
              )
            },
            cellStyle: { width: 'unset' },
          };
        case 'Upphandlingar': {
          const numberOfAreas = (rowData) => rowData.stepOneAreas + rowData.stepTwoAreas + rowData.stepThreeAreas + rowData.stepFourAreas;
          return {
            title: customHeader(COLUMN_NAMES.requests, 'totalAreas'),
            field: 'totalAreas',
            sorting: false,
            render: (rowData) => {
              const totalProjectAreas = numberOfAreas(rowData);
              return <div className="project-start__tenders-holder">
                <strong style={{ fontSize: '14px', color: 'var(--gray-900)' }}>{totalProjectAreas}</strong>
                <div className="project-start__tenders-status-holder">
                  {rowData.stepOneAreas > 0 && (
                    <TooltipContainer renderReferenceComponent={(className, ref) =>
                      <div className={`project-start__tenders-status ${className}`} ref={ref}>
                        <div className="project-start__tenders-status-symbol project-start__tenders-status-symbol--bid-request"></div>
                        <div className="project-start__tenders-status-text">{rowData.stepOneAreas}</div>
                      </div>
                    }>
                      {legends[0].label}
                    </TooltipContainer>
                  )}
                  {rowData.stepTwoAreas > 0 && (
                    <TooltipContainer renderReferenceComponent={(className, ref) =>
                      <div className={`project-start__tenders-status ${className}`} ref={ref}>
                        <div className="project-start__tenders-status-symbol project-start__tenders-status-symbol--evaluation"></div>
                        <div className="project-start__tenders-status-text">{rowData.stepTwoAreas}</div>
                      </div>
                    }>
                      {legends[1].label}
                    </TooltipContainer>
                  )}
                  {rowData.stepThreeAreas > 0 && (
                    <TooltipContainer renderReferenceComponent={(className, ref) =>
                      <div className={`project-start__tenders-status ${className}`} ref={ref}>
                        <div className="project-start__tenders-status-symbol project-start__tenders-status-symbol--negotiation"></div>
                        <div className="project-start__tenders-status-text">{rowData.stepThreeAreas}</div>
                      </div>
                    }>
                      {legends[2].label}
                    </TooltipContainer>
                  )}
                  {rowData.stepFourAreas > 0 && (
                    <TooltipContainer renderReferenceComponent={(className, ref) =>
                      <div className={`project-start__tenders-status ${className}`} ref={ref}>
                        <div className="project-start__tenders-status-symbol project-start__tenders-status-symbol--agreement"></div>
                        <div className="project-start__tenders-status-text">{rowData.stepFourAreas}</div>
                      </div>
                    }>
                      {legends[3].label}
                    </TooltipContainer>
                  )}
                </div>
              </div>
            },
            cellStyle: { width: 'unset' },
            align: 'left'
          }
        }
        case 'Estimerad projektkostnad': {
          return {
            title: customHeader(COLUMN_NAMES.estCost, 'estimatedCost'),
            field: 'estimatedCost',
            sorting: false,
            render: (rowData) => {
              let foundCost = appEnum
                .getProjectCostDataSource()
                .find(id => id.key == rowData.estimatedCost);

              return t('table.row.estCost', '{{estimatedCost}} MSEK', { estimatedCost: foundCost?.value })
            },
            emptyValue: '-',
            cellStyle: { width: '250px' },
          }
        }
      }
    }), {
      title: '',
      align: 'center',
      render: (rowData) => isWriteAccessRole && (
        <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          {!isLoading && <OptionsMenu style={{ width: '100%', height: '100%', display: 'grid', placeItems: 'center' }} options={[
            {
              label: t('settings.edit', 'Redigera'),
              action: async () => {
                try {
                  const fullProject = await ServiceProjects.getProject(rowData.slug);
                  const project = Array.isArray(fullProject) ? fullProject[0] : fullProject;
                  const formattedProject = {
                    _id: project._id,
                    name: project.name,
                    province: project.province,
                    address: project.address,
                    phase: project.phase,
                    entreprenad: project.entreprenad,
                    projectType: project.projectType,
                    projectTypeName: project.projectTypeName,
                    customer: project.customer,
                    estimatedCost: project.estimatedCost,
                    number: project.number,
                    slug: project.slug,
                    responsible: project.responsible,
                    user: project.user,
                    nextProjectId: project.nextProjectId,
                    nextCustomerId: project.nextCustomerId,
                  };
                  setClientValidForEdit(false);
                  setProjectToEdit(formattedProject);
                  setShowEditModal(true);
                } catch (error) {
                  console.error('Failed to fetch project details:', error);
                }
              },
              icon: <EditIcon color='var(--gray-700)' style={{ width: 16, height: 16 }} />
            },
            {
              label: t('table.row.tools.clearNotifications', 'Markera alla meddelanden som lästa'),
              action: async () => {
                const clearedNotifications = await clearNotifications(rowData._id, rowData.name);
                if (clearedNotifications) {
                  setProjects(oldProjects => oldProjects.map(oldProject =>
                    oldProject._id === rowData._id ? { ...oldProject, notification: 0 } : oldProject
                  ))
                }
              },
              icon: <EmailCheckIcon color='var(--gray-700)' />
            },
            rowData.nextProjectId && appState.currentOrganization.nextProjectAllowImport && {
              label: t('singleProject.button.updateFromNext', 'Hämta från Next Project'),
              action: () => {
                setUpdateFromNextRow(rowData);
                setUpdateFromNextModalKey(prev => prev + 1);
                setShowUpdateFromNextModal(true);
              },
              icon: <DownloadIcon color="var(--gray-700)" style={{ width: 16, height: 16 }} />,
            },
            appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && {
              label: rowData.nextProjectId ? t('singleProject.button.updateToNext', 'Skicka till Next Project') : t('singleProject.button.sendToNext', 'Skicka till Next Project'),
              action: async () => {
                if (rowData.nextProjectId && rowData.nextCustomerId) {
                  appState.setAutosavingState(SavingState.SAVING);
                  try {
                    // Compare the linked purchases against Next first; only a
                    // conflict-free project is sent directly like before.
                    const preview = await ServiceNextProject.previewExport(rowData._id);
                    // Mirror NextConflictSection's own hasContent check —
                    // missingAccounts renders a warning there too, so gating on
                    // conflicts/willBeRecreated alone would send those straight
                    // through and the user would only learn from the toast.
                    if (preview.conflicts.length > 0
                      || preview.willBeRecreated.length > 0
                      || (preview.missingAccounts?.length ?? 0) > 0) {
                      appState.setAutosavingState(SavingState.HIDDEN);
                      setExportNextProjectRow(rowData);
                      setExportNextPreview(preview);
                      setExportNextModalKey(prev => prev + 1);
                      setShowExportNextModal(true);
                      return;
                    }
                    await autosave(async () => {
                      const response = await ServiceNextProject.exportProject(rowData._id);
                      onSendToNextSuccess(response);
                    });
                  } catch (e) {
                    appState.setAutosavingState(SavingState.HIDDEN);
                    onSendToNextError(e);
                  }
                } else {
                  setExportNextProjectRow(rowData);
                  setExportNextPreview(null);
                  setExportNextModalKey(prev => prev + 1);
                  setShowExportNextModal(true);
                }
              },
              icon: <UploadIcon color="var(--gray-700)" style={{ width: 16, height: 16 }} />,
            },
            {
              label: rowData.isOpen
                ? t('singleProject.button.endProject', 'Avsluta projektet')
                : t('singleProject.button.restartProject', 'Återuppta projektet'),
              action: async () => {
                try {
                  const newStatus = !rowData.isOpen;
                  if (newStatus) {
                    await updateProjectOpen(newStatus, rowData);
                  } else {
                    setShowFinishProjectModal(true);
                    setFinishProjectInfo(rowData);
                  }
                } catch (error) {
                  console.error('Failed to toggle project status:', error);
                  NotificationManager.error(
                    t('notification.error.description.statusUpdateFailed', 'Det gick inte att uppdatera projektstatus.'),
                    t('notification.error.title.statusUpdateFailed', 'Misslyckat')
                  );
                }
              },
              icon: <PowerIcon color="var(--gray-700)" style={{ width: 16, height: 16 }} />
            },
            {
              label: t('table.row.tools.removeProject', 'Ta bort projekt'),
              action: async () => {
                const isProjectRemoved = await removeProject(rowData._id, rowData.name, rowData.slug);
                if (isProjectRemoved) {
                  refreshProjectList();
                }
              },
              icon: <TrashIcon color="var(--gray-700)" size="16px" />
            },
          ].filter(x=>x)} />}
        </div>
      ),
      cellStyle: { width: 'unset' },
      width: '30px'
    }];
  }

  const legends = useMemo(() => [
    {
      color: 'var(--darkBlue)',
      label: t('table.legends.request', 'Förfrågan'),
    },
    {
      color: 'var(--sunglowYellow)',
      label: t('table.legends.evaluation', 'Utvärdering'),
    },
    {
      color: 'var(--crayolaGreen)',
      label: t('table.legends.negotiation', 'Förhandling'),
    },
    {
      color: 'var(--gray-500)',
      label: t('table.legends.agreement', 'Avtal'),
    },
  ], [t]);

  const onSubmitFilter = useCallback((appliedFilters) => {
    setFiltersData(appliedFilters);
    // Reset to page 1 when filters are applied
    updatePageInURL(1, true);
    setCurrentPage(1);
  }, [updatePageInURL]);

  const onCancelFilter = useCallback(() => {
    toggleFilter(!showFilter);
    let resetFilter = { kommun: [], projectType: [], phase: [], users: [], next: [] };
    setFiltersData(resetFilter);
    // Reset to page 1 when filters are cleared
    updatePageInURL(1, true);
    setCurrentPage(1);
  }, [showFilter, filtersData, updatePageInURL]);

  const filterCheckboxes = useMemo(() => [
    ...(appState.currentOrganization.hasNextProject ? [{
      label: (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
          {t('filter.nextProject.label', 'Next Project')}
          <span style={{ fontSize: '10px', fontWeight: 500, color: '#92400E', background: '#FEF3C7', borderRadius: '10px', padding: '2px 7px' }}>
            {t('filter.nextProject.newBadge', 'Ny')}
          </span>
        </span>
      ),
      name: 'next',
      value: filtersData.next || [],
      subChecks: [
        { label: t('filter.nextProject.linked', 'Kopplad'), name: 'next', value: 'linked' },
        { label: t('filter.nextProject.notLinked', 'Ej kopplad'), name: 'next', value: 'notLinked' },
      ],
    }] : []),
    {
      label: COLUMN_NAMES.region,
      name: 'kommun',
      value: filtersData.kommun || (cities[0]?.value ?? ''),
      subChecks: cities.map(city => ({
        label: city.label,
        name: 'kommun',
        value: city.value,
      }))
    },
    {
      label: COLUMN_NAMES.projectType,
      name: 'projectType',
      value: filtersData.projectType,
      subChecks: projectTypes.map(pt => ({
        label: pt.label && t(`projectType.${pt.label.replace(/[\s&/]/g, '')}`, pt.label),
        name: 'projectType',
        value: pt.label,
      }))
    },
    {
      label: COLUMN_NAMES.phase,
      name: 'phase',
      value: filtersData.phase || '',
      subChecks: [
        { label: t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'), name: 'phase', value: 'Anbud/Kalkyl' },
        { label: t('projectPhase.InköpProduktion', 'Inköp/Produktion'), name: 'phase', value: 'Inköp/Produktion' },
        { label: t('projectPhase.empty', 'Ej angivet'), name: 'phase', value: '' }
      ],
    },
    {
      label: COLUMN_NAMES.users,
      name: 'users',
      value: filtersData.users || [],
      subChecks: (() => {
        const currentUser = appState.getLoggedInUserDetail();
        const userOptions = users
          .filter(user => user.value) // Filter out users without valid IDs
          .map(user => ({
            label: user.label,
            name: 'users',
            value: user.value,
          }));

        const currentUserExists = userOptions.find(user => user.value === currentUser?.id);
        if (!currentUserExists && currentUser) {
          userOptions.unshift({
            label: currentUser.name,
            name: 'users',
            value: currentUser.id,
          });
        }

        return userOptions;
      })()
    },

  ], [cities, projectTypes, filtersData, t, users]);

  const tableColumns = useMemo(() => getColumns().filter((x) => x), [columns, sortConfig, isLoading]);
  const numberOfPages = totalPages;

  return (
    <AppLayout title={t('pageTitle', 'Projekt')}>
      <div className="pageProjectStartContainer">
        <div className="tab-container">
          <Tabs
            tabs={[t('tabs.ongoing', 'Pågående Projekt'), t('tabs.expired', 'Avslutade Projekt')]}
            selected={selectedProjectTab}
            onChange={setSelectedProjectTab}
          />
          {isWriteAccessRole && (
            <div className="tab-actions">
              <BtButton onClick={async () => {
                const clearedNotifications = await clearAllNotifications();
                if (clearedNotifications) {
                  setProjects(oldProjects => oldProjects.map(oldProject => ({ ...oldProject, notification: 0 })));
                }
              }} color="white">{t('button.clearNotifications', 'Rensa aviseringar')}</BtButton>
              {appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowImport && (
                <BtButton color="white" onClick={() => {setShowNextImportModal(true); setNextImportModalKey(nextImportModalKey + 1)}}>{t('button.importFromNext', 'Importera från Next')}</BtButton>
              )}
              <BtButton onClick={addProject}>{t('button.newProject', 'Nytt projekt')}</BtButton>
            </div>
          )}
        </div>
        <SearchBarWithActions value={searchValue} onChange={search}>
          <FiltersDropdown
            onSubmitFilter={onSubmitFilter}
            onResetFilter={onCancelFilter}
            checkboxes={filterCheckboxes}
            showFilter={showFilter}
            toggleFilter={toggleFilter}
            filtersData={filtersData}
            preferenceName={appEnum.userPrefrences.projectFilter}
            multiple
          />
          <CustomizationMenu columns={columns} setColumns={updateColumns} />
        </SearchBarWithActions>

        {/* Spacing Div */}
        <div style={{ height: '32px' }} />

        <DataTable
          tableRef={tableRef}
          isLoading={isLoading}
          sorting={false}
          columns={tableColumns}
          data={projects}
          onRowClick={useCallback((e, rowData) => {
            const orgSlug = appState._getCurrentOrgUrl();
            // Store current URL (with page number) relative to org slug, so back button can return to it
            // CustomNavLink will prepend the org slug, so we only store the relative path
            const pathname = history.location.pathname;
            const orgPrefix = orgSlug || '';
            const relativePath = pathname.startsWith(orgPrefix)
              ? pathname.slice(orgPrefix.length)
              : pathname;
            const relativeUrl = relativePath + history.location.search;

            history.push({
              pathname: `${orgSlug}/projects/${rowData.slug}`,
              state: { fromProjectsList: relativeUrl }
            });
          }, [history.location.pathname, history.location.search, appState._getCurrentOrgUrl()])}
          isScrollable={true}
          style={{ maxHeight: 'none' }}
        />

        {numberOfPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <PaginationWithGoTo
              count={numberOfPages}
              onChange={(_, value) => {
                // Set flag first to prevent history listener interference
                isUpdatingURL.current = true;
                // Update state and URL
                setCurrentPage(value);
                updatePageInURL(value, false);
              }}
              page={currentPage}
              t={tPagination}
            />
          </div>
        )}

        <Modal
          title={t('singleProject.button.endProject', 'Avsluta projektet')}
          show={showFinishProjectModal}
          buttonInfo={{
            label: t('singleProject.button.endProject', 'Avsluta projektet'),
            action: async () => {
              setFinishProjectLoader(true);
              await updateProjectOpen(!finishProjectInfo.isOpen, finishProjectInfo);
              setFinishProjectLoader(false);
              setShowFinishProjectModal(false);
            },
            loaderShow: finishProjectLoader
          }}
          setShow={(value) => {
            setShowFinishProjectModal(false);
            setTimeout(() => setShowFinishProjectModal(value), 500)
          }}
        >
          <div style={{ color: 'var(--gray-700)', fontSize: '14px', maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span>
              <Trans t={t} i18nKey="finishProject.message" finishProjectInfoName={finishProjectInfo?.name}>
                Vill du avsluta projektet &quot;<span style={{ fontWeight: '500' }}>{{ finishProjectInfoName: finishProjectInfo?.name }}</span>&quot;?
              </Trans>
            </span>
            <span>
              <Trans t={t} i18nKey="finishProject.quotationLinks.wontWork">
                Avslutar du projektet stängs åtkomsten till samtliga förfrågningar. Leverantörer kan inte längre öppna eller svara på dem.
              </Trans>
            </span>
          </div>
        </Modal>
        <Modal
          title={t('settings.edit', 'Redigera')}
          show={showEditModal}
          buttonInfo={{
            label: appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && projectToEdit?.nextProjectId
              ? t('createProject.button.edit', 'Spara')
              : t('createProject.button.edit', 'Spara') + (
                appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && parentProjectForEdit
                  ? t('createProject.button.sendTo', ' och skicka till Next')
                  : ''
              ),
            action: () => {
              if (appCreateProjectRef.current) {
                if (appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && projectToEdit?.nextProjectId) {
                  setEditingProject(true);
                } else if (appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && parentProjectForEdit) {
                  setSendToNext(true);
                } else {
                  setEditingProject(true);
                }
                appCreateProjectRef.current.btnCreateProjectClickCallback();
              }
            },
            loaderShow: editingProject,
            disabled: editingProject || sendToNext || (appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && !projectToEdit?.nextProjectId && !!parentProjectForEdit && !clientValidForEdit)
          }}
          containerBeforeButtons={
            <>
              <BtButton color='white' disabled={editingProject || sendToNext} onClick={() => { setShowEditModal(false); setProjectToEdit(null); setParentProjectForEdit(null); setClientValidForEdit(false); }}>{t('createProject.button.cancel', 'Avbryt')}</BtButton>
              {appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport && projectToEdit?.nextProjectId && (
                <BtButton
                  color='white'
                  disabled={editingProject || sendToNext || !clientValidForEdit}
                  loaderShow={sendToNext}
                  onClick={() => {
                    if (appCreateProjectRef.current) {
                      setSendToNext(true);
                      appCreateProjectRef.current.btnCreateProjectClickCallback();
                    }
                  }}
                >
                  {t('createProject.button.edit', 'Spara') + t('createProject.button.updateTo', ' och uppdatera till Next')}
                </BtButton>
              )}
            </>
          }
          hasCloseButton={true}
          setShow={(value) => {
            setShowEditModal(value);
            if (!value) {
              setProjectToEdit(null);
              setParentProjectForEdit(null);
              setClientValidForEdit(false);
            }
          }}          
        >
          <AppCreateProject
            ref={appCreateProjectRef}
            currentProject={projectToEdit}
            users={users}
            onParentProjectChange={(v) => setParentProjectForEdit(v)}
            onCustomerMappingChange={(valid) => setClientValidForEdit(valid)}
            onProjectUpdateCreated={async (sender, updatedProject) => {
              if (sendToNext && appState.currentOrganization.hasNextProject && appState.currentOrganization.nextProjectAllowExport) {
                try {
                  const response = await ServiceNextProject.exportProject(updatedProject._id, parentProjectForEdit?.value);
                  onSendToNextSuccess(response);
                } catch (err) {
                  onSendToNextError(err);
                }
              }
              await refreshProjectList();
              setShowEditModal(false);
              setProjectToEdit(null);
              setEditingProject(false);
              setSendToNext(false);
              setParentProjectForEdit(null);
            }}
            allNextProjects={allNextProjects}
            fetchAllNextProjects={fetchAllNextProjects}
            allNextCustomers={allNextCustomers}
            fetchAllNextCustomers={fetchAllNextCustomers}
          />
        </Modal>
        <ImportNextProjectModal
          show={showNextImportModal}
          setShow={() => {
            setShowNextImportModal(false);
            refreshProjectList();
          }}
          key={`ImportNextProjectModal${nextImportModalKey}`}
          allNextProjects={allNextProjects}
          fetchAllNextProjects={fetchAllNextProjects}
        />
        <ExportNextProjectModal
          show={showExportNextModal}
          setShow={setShowExportNextModal}
          projectId={exportNextProjectRow?._id}
          nextProjectId={exportNextProjectRow?.nextProjectId}
          nextCustomerId={exportNextProjectRow?.nextCustomerId}
          key={`ExportNextProjectModal${exportNextModalKey}`}
          onSuccess={onSendToNextSuccess}
          onError={onSendToNextError}
          allNextProjects={allNextProjects}
          fetchAllNextProjects={fetchAllNextProjects}
          allNextCustomers={allNextCustomers}
          fetchAllNextCustomers={fetchAllNextCustomers}
          initialPreview={exportNextPreview}
        />
        <UpdateFromNextModal
          show={showUpdateFromNextModal}
          setShow={setShowUpdateFromNextModal}
          nextProjectId={updateFromNextRow?.nextProjectId ?? null}
          key={`UpdateFromNextModal${updateFromNextModalKey}`}
          onSuccess={onUpdateFromNextSuccess}
          onError={onUpdateFromNextError}
        />
      </div>
    </AppLayout>
  );
}
